import { template as template_d453566f0a564afea7959a7563d9c625 } from "@ember/template-compiler";
import PracticeWebsiteJumpLink from 'client-portal/components/practice-website/jump-link';
import styles from './nav.module.scss';
import t from 'ember-intl/helpers/t';
export default template_d453566f0a564afea7959a7563d9c625(`
  <nav
    class="{{styles.component}} pw-nav"
    aria-label={{t "practiceWebsite.nav.ariaLabel"}}
    ...attributes
  >
    <ul class="nav-list" data-test-nav-list>
      <li>
        <PracticeWebsiteJumpLink @target="home" @onClick={{@onClick}} @offset={{0}}>
          Home
        </PracticeWebsiteJumpLink>
      </li>
      <li>
        <PracticeWebsiteJumpLink @target="about" @onClick={{@onClick}}>
          About
        </PracticeWebsiteJumpLink>
      </li>
      {{#if @showSectionSpecialties}}
        <li>
          <PracticeWebsiteJumpLink @target="services" @onClick={{@onClick}}>
            Services
          </PracticeWebsiteJumpLink>
        </li>
      {{/if}}
      {{#if @showSectionTestimonials}}
        <li>
          <PracticeWebsiteJumpLink @target="testimonials" @onClick={{@onClick}}>
            Testimonials
          </PracticeWebsiteJumpLink>
        </li>
      {{/if}}
      {{#if @showSectionLocations}}
        <li data-test-locations-link>
          <PracticeWebsiteJumpLink @target="locations" @onClick={{@onClick}}>
            {{@locationsSectionTitle}}
          </PracticeWebsiteJumpLink>
        </li>
      {{/if}}
    </ul>
  </nav>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
